import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUseCaseGoodFit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			rx: 2,
			fill: "#3C59F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 7.08396L4.49416 8.57811L8.07227 5",
			stroke: "white",
			strokeWidth: 1.20425,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.39062 7.55661L7.88478 9.05077L11.4629 5.47266",
			stroke: "white",
			strokeWidth: 1.20425,
			strokeLinecap: "round"
		})
	]
});
export default SvgUseCaseGoodFit;
